import { format, parse } from 'date-fns';
import React from 'react';
import smartlookClient from 'smartlook-client';
import DateFnsUtils from '@date-io/date-fns';
import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { QuoteSearchCard } from '../QuoteSearchCard';
import { DeereFetch, DeereCachedFetch } from '../../shared/fetch';
import { StatusService } from '../../services/status';
import { AuthService } from '../../services/auth';
import { Pagination } from '../Pagination';
import { SortColumn } from '../SortColumn';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import {getKey} from '../GenerateKey';

const styles = {
    expansionHeader: {
        display: 'flex',
        padding: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        position: 'sticky',
        top: 0,
        zIndex: 2
    },
    heading: {
        display: 'block',
        fontSize: '15px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        margin: 'auto 5px',
        flex: 1,
        fontWeight: 'bold'
    },
    icons: {
        fontSize: 22,
        marginLeft: 4
    },
    links: {
        display: 'flex',
        alignItems: 'center'
    }
};

styles.assign = Object.assign({}, styles.heading, {
    textAlign: 'right',
    flex: 2
});

styles.message = Object.assign({}, styles.heading, {
    flex: 2
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250
        }
    }
};

export class SearchPage extends React.Component {
    constructor(props) {
        super(props);

        const url = new URL(location.href);
        this.state = {
            users: [],
            countries: [],
            asmNames: [],
            daemonData: [],
            dealerNames: [],
            startDate: url.searchParams.get('startDate') || null,
            endDate: url.searchParams.get('endDate') || null,
            status: url.searchParams.get('status') ? [url.searchParams.get('status')] : [],
            statusID: url.searchParams.get('statusID') || '',
            icsID: url.searchParams.get('icsID') || '',
            assignedTo: url.searchParams.get('assignedTo') || '',
            quoteNumber: url.searchParams.get('quoteNumber') || '',
            bundleNumber: url.searchParams.get('bundleNumber') || '',
            countryCodes: url.searchParams.get('countryCodes') || '',
            resubmitted: url.searchParams.get('resubmitted') || '',
            dealerRef: url.searchParams.get('alfaDealerIdentifier') || '',
            asm: url.searchParams.get('asm') || '',
            dealer: url.searchParams.get('dealer') || '',
            sort: url.searchParams.get('sort') || '',
            direction: url.searchParams.get('direction') || '',
            numberOfPages: 0,
            currentPage: (Number(url.searchParams.get('page')) || 1) - 1,
            expanded: url.searchParams.get('expanded'),
            salespeople: [],
            salesPerson: url.searchParams.get('salesPerson') || ''
        };

        if (this.state.startDate) {
            this.state.startDate = parse(this.state.startDate, 'yyyy/MM/dd', new Date());
        }

        if (this.state.endDate) {
            this.state.endDate = parse(this.state.endDate, 'yyyy/MM/dd', new Date());
        }

        this.handleChange = this.handleChange.bind(this);
        this.search = this.search.bind(this);
        this.clear = this.clear.bind(this);
        this.onExpanded = this.onExpanded.bind(this);

        this.expanded = React.createRef();
    }

    async componentDidMount() {
        smartlookClient.record({ forms: true, numbers: true, emails: false });
        await this.search(this.state.currentPage);

        this.setState({
            loading: true
        });
        try {
            const promises = [];

            promises.push(AuthService.user.then(async (user) => {
                const users = await DeereCachedFetch('/api/users', {
                    query: {
                        countries: user.countries.map(({ id }) => id.countryCode),
                        roles: ['ASSIGN', 'ADMIN'],
                        sort: 'firstName,asc'
                    }
                });

                return [user, users];
            }));

            promises.push(DeereCachedFetch('/api/countries', {
                cacheDuration: 'forever'
            }));

            promises.push(StatusService.friendlyProposalStatusesList);
            const [[user, users], countries, statuses] = await Promise.all(promises);

            const npromises = [];
            let countriesOfUser = '';
            user.countries.forEach(({ id }) => countriesOfUser = countriesOfUser + id.countryCode + ',');

            npromises.push(DeereCachedFetch('/api/dealers?country=' + countriesOfUser, {
                cacheDuration: 'forever'
            }));

            npromises.push(DeereCachedFetch('/api/asms?country=' + countriesOfUser, {
                cacheDuration: 'forever'
            }));

            let cntries = '';
            user.countries.map((u) => {
                cntries = cntries + u.id.countryCode + ':';
            });

            npromises.push(DeereCachedFetch('/api/salespeople/' + cntries, {
                cacheDuration: 'forever'
            }));

            const [dealerNames, asmNames, salesPeople] = await Promise.all(npromises);

            const proposalLoader = await DeereCachedFetch('/api/daemon', {
                cacheDuration: 'forever'
            });

            this.setState({
                user,
                users,
                countries: countries && Object.entries(countries).filter(([code]) => {
                    return !!user.countries.find(({ id }) => id.countryCode === code);
                }).map(([code, name]) => ({
                    value: code,
                    label: name
                })),
                statuses,
                asmNames,
                salespeople: salesPeople,
                daemonData: proposalLoader,
                dealerNames
            });
        } finally {
            this.setState({
                loading: false
            });
        }

        if (this.expanded.current) this.expanded.current.scrollTo();
    }

    handleChange(name) {
        return (e) => {
            this.setState({
                [name]: e.target.value
            });
        };
    }

    onExpanded(quoteNumber) {
        return (event, isExpanded) => {
            const url = new URL(location.href);
            if (isExpanded) {
                url.searchParams.set('expanded', quoteNumber);
                this.setState({
                    expanded: quoteNumber
                });
            } else {
                url.searchParams.delete('expanded');
                this.setState({
                    expanded: false
                });
            }
            history.pushState(null, `Page (${this.state.currentPage}/${this.state.numberOfPages}) • FC Utilities`, url.toString());
        }
    }


    render() {
        return (
            <div>

                {this.state.daemonData.map((data) => (
                    <span display="inline" key={'daemon-' + getKey()} style={{ marginBottom: 3 }}  >
                        <Chip color="primary" display="inline" label={'Proposal Daemon ' + data.country + ': ' + data.proposalDaemonDate} size="small" style={{ marginLeft: 3}} variant="outlined" />
                        <Chip color="primary" display="inline" label={'TP Daemon ' + data.country + ': ' + data.thirdPartyDaemonDate} size="small" style={{ marginLeft: 3}} variant="outlined" />
                    </span>
                ))}

                <Typography style={{ marginBottom: 10, marginTop: 5 }} variant="h5">Proposal Search</Typography>
                <Card style={{ marginBottom: 20 }}>
                    <CardContent>
                        <Grid container direction="row" item spacing={2} style={{ marginLeft: '2%' }}>
                            <Grid alignItems="flex-start" container direction="column" item justifyContent="space-between" sm={3} xs={6}>
                                <Typography style={{ fontWeight: 'bold' }}>Bundle</Typography>
                                <TextField
                                    id="bundle-number"
                                    margin="none"
                                    onChange={this.handleChange('bundleNumber')}
                                    placeholder="B000123"
                                    value={this.state.bundleNumber}
                                />
                            </Grid>
                            <Grid alignItems="flex-start" container direction="column" item justifyContent="space-between" sm={3} xs={6}>
                                <Typography style={{ fontWeight: 'bold' }}>Quote</Typography>
                                <TextField
                                    id="quote-number"
                                    margin="none"
                                    onChange={this.handleChange('quoteNumber')}
                                    placeholder="AALF001234"
                                    value={this.state.quoteNumber}
                                />
                            </Grid>
                            <Grid alignItems="flex-start" container direction="column" item justifyContent="space-between" sm={3} xs={6}>
                                <Typography style={{ fontWeight: 'bold' }}>ICS ID</Typography>
                                <TextField
                                    id="ics-id"
                                    margin="none"
                                    onChange={this.handleChange('icsID')}
                                    placeholder="146282"
                                    value={this.state.icsID}
                                />
                            </Grid>
                            <Grid alignItems="flex-start" container direction="column" item justifyContent="space-between" sm={3} xs={6}>
                                <Typography style={{ fontWeight: 'bold' }}>Status</Typography>


                                <Select
                                    MenuProps={MenuProps}
                                    input={<Input />}
                                    inputProps={{
                                        name: 'status',
                                        id: 'status'
                                    }}
                                    multiple
                                    onChange={this.handleChange('status')}
                                    renderValue={(selected) => selected.join(', ')}
                                    style={{ minWidth: 195 }}
                                    value={this.state.status}
                                >

                                    <MenuItem key="Open" value="Open" >
                                        <Checkbox checked={this.state.status.indexOf('Open') > -1}
                                            style={{
                                                color: '#25561e'
                                            }}

                                        />
                                        <ListItemText primary="Open" />

                                    </MenuItem>
                                    <MenuItem key="In Progress" value="In Progress" >
                                        <Checkbox checked={this.state.status.indexOf('In Progress') > -1}
                                            style={{
                                                color: '#25561e'
                                            }}

                                        />
                                        <ListItemText primary="In Progress" />

                                    </MenuItem>
                                    <MenuItem key="Closed" value="Closed" >
                                        <Checkbox checked={this.state.status.indexOf('Closed') > -1}
                                            style={{
                                                color: '#25561e'
                                            }}

                                        />
                                        <ListItemText primary="Closed" />

                                    </MenuItem>

                                </Select>

                            </Grid>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Grid alignItems="flex-start" container direction="column" item justifyContent="space-between" sm={3} xs={6}>
                                    <Typography style={{ fontWeight: 'bold' }}>Start Date</Typography>
                                    <KeyboardDatePicker
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date'
                                        }}
                                        autoOk
                                        disableFuture
                                        disableToolbar
                                        format="yyyy/MM/dd"
                                        id="start-date"
                                        maxDate={this.state.endDate}
                                        onChange={(value) => this.setState({ startDate: value })}
                                        required={false}
                                        style={{ maxWidth: 195 }}
                                        value={this.state.startDate}
                                        variant="inline"
                                    />
                                </Grid>
                                <Grid alignItems="flex-start" container direction="column" item justifyContent="space-between" sm={3} xs={6}>
                                    <Typography style={{ fontWeight: 'bold' }}>End Date</Typography>
                                    <KeyboardDatePicker
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date'
                                        }}
                                        autoOk
                                        disableFuture
                                        disableToolbar
                                        format="yyyy/MM/dd"
                                        id="end-date"
                                        minDate={this.state.startDate}
                                        onChange={(value) => this.setState({ endDate: value })}
                                        required={false}
                                        style={{ maxWidth: 195 }}
                                        value={this.state.endDate}
                                        variant="inline"
                                    />
                                </Grid>
                            </MuiPickersUtilsProvider>
                            <Grid alignItems="flex-start" container direction="column" item justifyContent="space-between" sm={3} xs={6}>
                                <Typography style={{ fontWeight: 'bold' }}>Resubmitted</Typography>
                                <Select
                                    inputProps={{
                                        name: 'resubmitted',
                                        id: 'resubmitted'
                                    }}
                                    onChange={this.handleChange('resubmitted')}
                                    style={{ minWidth: 195 }}
                                    value={this.state.resubmitted}>
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    <MenuItem value={true}>Yes</MenuItem>
                                    <MenuItem value={false}>No</MenuItem>
                                </Select>
                            </Grid>
                            <Grid alignItems="flex-start" container direction="column" item justifyContent="space-between" sm={3} xs={6}>
                                <Typography style={{ fontWeight: 'bold' }}>Assigned
                                </Typography>
                                <Select
                                    disabled={this.state.loading}
                                    inputProps={{
                                        name: 'assigned-user',
                                        id: 'assigned-user'
                                    }}
                                    onChange={this.handleChange('assignedTo')}
                                    style={{ minWidth: 195 }}
                                    value={this.state.assignedTo}>
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {this.state.users && this.state.users.map((user) => (
                                        <MenuItem key={user.id} value={user.id}>{user.firstName} {user.lastName}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <Grid alignItems="flex-start" container direction="column" item justifyContent="space-between" sm={3} xs={6}>
                                <Typography style={{ fontWeight: 'bold' }}>Message</Typography>
                                <Select
                                    disabled={this.state.loading}
                                    inputProps={{
                                        name: 'status-id',
                                        id: 'status-id'
                                    }}
                                    onChange={this.handleChange('statusID')}
                                    style={{ minWidth: 195 }}
                                    value={this.state.statusID}>
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {this.state.statuses && this.state.statuses.map(({ label, value }) => (
                                        <MenuItem key={value} value={value}>{label}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>

                            <Grid alignItems="flex-start" container direction="column" item justifyContent="space-between" sm={3} xs={6}>
                                <Typography style={{ fontWeight: 'bold' }}>Dealer</Typography>
                                <Select
                                    disabled={this.state.loading}
                                    inputProps={{
                                        name: 'dealer',
                                        id: 'dealer'
                                    }}
                                    onChange={this.handleChange('dealer')}
                                    style={{ minWidth: 195 }}
                                    value={this.state.dealer}>
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {this.state.dealerNames && this.state.dealerNames.map(value => (
                                        <MenuItem key={value} value={value}>{value}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <Grid alignItems="flex-start" container direction="column" item justifyContent="space-between" sm={3} xs={6}>
                                <Typography style={{ fontWeight: 'bold' }}>ASM</Typography>
                                <Select
                                    disabled={this.state.loading}
                                    inputProps={{
                                        name: 'asm',
                                        id: 'asm'
                                    }}
                                    onChange={this.handleChange('asm')}
                                    style={{ minWidth: 195 }}
                                    value={this.state.asm}>

                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {this.state.asmNames && this.state.asmNames.map(value => (
                                        <MenuItem key={value} value={value}>{value}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <Grid alignItems="flex-start" container direction="column" item justifyContent="space-between" sm={3} xs={6}>
                                <Typography style={{ fontWeight: 'bold' }}>Sales Person</Typography>
                                <Select
                                    disabled={this.state.loading}
                                    inputProps={{
                                        name: 'salesPerson',
                                        id: 'salesPerson'
                                    }}
                                    onChange={this.handleChange('salesPerson')}
                                    style={{ minWidth: 195 }}
                                    value={this.state.salesPerson}>
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {this.state.salespeople && this.state.salespeople.map(value => (
                                        <MenuItem key={value} value={value}>{value}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            {this.state.countries && this.state.countries.length > 1 && (
                                <Grid alignItems="flex-start" container direction="column" item justifyContent="space-between" sm={3} xs={6}>
                                    <Typography style={{ fontWeight: 'bold' }}>Country</Typography>
                                    <Select
                                        disabled={this.state.loading}
                                        inputProps={{
                                            name: 'country-code',
                                            id: 'country-code'
                                        }}
                                        onChange={this.handleChange('countryCodes')}
                                        style={{ minWidth: 195 }}
                                        value={this.state.countryCodes}>
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {this.state.countries && this.state.countries.map(({ value, label }) => (
                                            <MenuItem key={value} value={value}>{label || value}</MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                            )}
                        </Grid>
                    </CardContent>
                </Card>

                <Grid
                    alignItems="center"
                    container
                    direction="row"
                    justifyContent="flex-end"
                    style={{ marginBottom: 20 }}>
                    <div style={{ flex: 1 }}></div>
                    <Button disabled={this.state.loading || !this.hasSearchParameters()}
                        onClick={this.clear}
                        style={{ marginLeft: 10 }}
                        variant="contained">
                        Clear
                    </Button>
                    <div style={{ position: 'relative', marginLeft: 10 }}>
                        <Button
                            color="primary"
                            disabled={this.state.loading}
                            onClick={() => this.search(0, true)}
                            variant="contained">
                            Search
                        </Button>
                        {this.state.loading && <CircularProgress disableShrink size={24} style={{ position: 'absolute', top: '50%', left: '50%', marginTop: -12, marginLeft: -12 }} />}
                    </div>
                </Grid>

                {this.state.quotes && this.state.quotes.length > 0 && (
                    <div>
                        <Grid
                            alignItems="center"
                            container
                            direction="row"
                            justifyContent="space-between"
                            spacing={3}
                            style={{ marginBottom: 10 }}>
                            <Grid item>
                                <Pagination currentPage={this.state.currentPage}
                                    disabled={this.state.loading}
                                    numberOfPages={this.state.numberOfPages}
                                    onSelect={(page) => this.search(page, true)} />
                            </Grid>
                            <Grid item>
                                <Typography>Displaying {this.state.currentPage * this.state.pageSize + 1} - {this.state.currentPage * this.state.pageSize + this.state.quotesPerPage} of {this.state.totalNumberOfQuotes}</Typography>
                            </Grid>
                        </Grid>

                        <div>
                            <Paper style={styles.expansionHeader}>
                                <SortColumn activeSort={this.state.sort} direction={this.state.direction} onSort={(sort, direction) => {
                                    this.setState({ sort, direction }, () => this.search(null, true));
                                }} sort="bundleNumber">Bundle</SortColumn>
                                <SortColumn activeSort={this.state.sort} direction={this.state.direction} onSort={(sort, direction) => {
                                    this.setState({ sort, direction }, () => this.search(null, true));
                                }} sort="quoteNumber">Quote</SortColumn>
                                <SortColumn activeSort={this.state.sort} direction={this.state.direction} onSort={(sort, direction) => {
                                    this.setState({ sort, direction }, () => this.search(null, true));
                                }} sort="countryCodes">Country</SortColumn>
                                <SortColumn activeSort={this.state.sort} direction={this.state.direction} onSort={(sort, direction) => {
                                    this.setState({ sort, direction }, () => this.search(null, true));
                                }} sort="status">Status</SortColumn>
                                <SortColumn activeSort={this.state.sort} direction={this.state.direction} onSort={(sort, direction) => {
                                    this.setState({ sort, direction }, () => this.search(null, true));
                                }} sort="createdDate">Submit Date</SortColumn>
                                <SortColumn activeSort={this.state.sort} direction={this.state.direction} onSort={(sort, direction) => {
                                    this.setState({ sort, direction }, () => this.search(null, true));
                                }} sort="assignment.userID">Assigned User</SortColumn>
                                {['ASSIGN', 'ADMIN'].includes(AuthService.role) && (
                                    <SortColumn disabled style={{ flex: 2, textAlign: 'right' }}>Assign To</SortColumn>
                                )}
                            </Paper>
                            {this.state.quotes.map((quote, index) => (
                                <QuoteSearchCard expanded={this.state.expanded === quote.quoteNumber}
                                    id={quote.quoteNumber}
                                    key={quote.quoteNumber}
                                    onChange={(quote) => {
                                        this.setState((prevState) => ({
                                            quotes: prevState.quotes.map((existingQuote, quoteIndex) =>
                                                (quoteIndex === index ? quote : existingQuote))
                                        }));
                                    }} onExpanded={this.onExpanded(quote.quoteNumber)}
                                    quote={quote}
                                    ref={this.state.expanded === quote.quoteNumber ? this.expanded : null} />
                            ))}
                        </div>

                        <Grid
                            alignItems="center"
                            container
                            direction="row"
                            justifyContent="space-between"
                            spacing={3}
                            style={{ marginBottom: 10 }}>
                            <Grid item>
                                <Pagination currentPage={this.state.currentPage}
                                    disabled={this.state.loading}
                                    numberOfPages={this.state.numberOfPages}
                                    onSelect={(page) => this.search(page, true)} />
                            </Grid>
                            <Grid item>
                                <Typography>Displaying {this.state.currentPage * this.state.pageSize + 1} - {this.state.currentPage * this.state.pageSize + this.state.quotesPerPage} of {this.state.totalNumberOfQuotes}</Typography>
                            </Grid>
                        </Grid>
                    </div>
                )}
            </div>
        )
    }



    hasSearchParameters() {
        return !!this.state.quoteNumber ||
      !!this.state.bundleNumber ||
      !!this.state.countryCodes ||
      !!this.state.resubmitted ||
      !!this.state.assignedTo ||
      !!this.state.icsID ||
      !!this.state.statusID ||
      !!this.state.status ||
      !!this.state.startDate ||
      !!this.state.endDate ||
      !!this.state.dealerRef ||
      !!this.state.sort ||
      !!this.state.salesPerson ||
      !!this.state.direction;


    }

    clear() {
        this.setState({
            startDate: null,
            endDate: null,
            status: [],
            statusID: '',
            icsID: '',
            assignedTo: '',
            quoteNumber: '',
            bundleNumber: '',
            dealerRef: '',
            countryCodes: '',
            resubmitted: '',
            sort: '',
            direction: '',
            salesPerson: ''
        });
    }

    async search(page, reflect) {
        if ([undefined, null].includes(page)) {
            page = this.state.currentPage;
        }
        page = Math.max(0, page);

        this.setState({
            error: null,
            loading: true
        });

        try {
            const quotesPage = await DeereFetch('/api/quotes', {
                query: {
                    startDate: this.state.startDate,
                    endDate: this.state.endDate,
                    assignedTo: this.state.assignedTo,
                    statusID: this.state.statusID,
                    status: this.state.status,
                    icsID: this.state.icsID,
                    bundleNumber: this.state.bundleNumber,
                    quoteNumber: this.state.quoteNumber,
                    dealerRef: this.state.dealerRef,
                    countryCodes: this.state.countryCodes,
                    salesPerson: this.state.salesPerson,
                    resubmitted: this.state.resubmitted,
                    asm: this.state.asm,
                    dealer: this.state.dealer,
                    size: 100,
                    page: page,
                    sort: this.state.sort ? `${this.state.sort},${this.state.direction}` : null
                }
            });

            if (quotesPage.totalPages !== 0 && page >= quotesPage.totalPages) {
                await this.search(0, true);
            } else {
                this.setState({
                    totalNumberOfQuotes: quotesPage.totalItemCount,
                    pageSize: quotesPage.pageSize,
                    quotesPerPage: quotesPage.itemCount,
                    quotes: quotesPage.content,
                    numberOfPages: quotesPage.pageCount,
                    currentPage: quotesPage.page
                });

                const url = new URL(location.href);
                url.searchParams.forEach((_, key) => url.searchParams.delete(key));

                if (this.state.startDate) url.searchParams.set('startDate', format(this.state.startDate, 'yyyy/MM/dd'));
                if (this.state.endDate) url.searchParams.set('endDate', format(this.state.endDate, 'yyyy/MM/dd'))
                if (this.state.assignedTo) url.searchParams.set('assignedTo', this.state.assignedTo);
                if (this.state.status) url.searchParams.set('status', this.state.status);
                if (this.state.statusID) url.searchParams.set('statusID', this.state.statusID);
                if (this.state.icsID) url.searchParams.set('icsID', this.state.icsID);
                if (this.state.bundleNumber) url.searchParams.set('bundleNumber', this.state.bundleNumber);
                if (this.state.quoteNumber) url.searchParams.set('quoteNumber', this.state.quoteNumber);
                if (this.state.countryCodes) url.searchParams.set('countryCodes', this.state.countryCodes);
                if (this.state.salesPerson) url.searchParams.set('salesPerson', this.state.salesPerson);
                if (this.state.resubmitted) url.searchParams.set('resubmitted', this.state.resubmitted);
                if (this.state.sort) url.searchParams.set('sort', this.state.sort);
                if (this.state.direction) url.searchParams.set('direction', this.state.direction);
                if (quotesPage.page) url.searchParams.set('page', quotesPage.page + 1);

                if (reflect) {
                    history.pushState(null, `Page (${quotesPage.page}/${quotesPage.pageCount}) • FC Utilities`, url.toString());
                }
            }
        } catch (error) {
            this.setState({ error });
        } finally {
            this.setState({
                loading: false
            });
        }
    }
}
